import { getTokens } from 'config/constants/tokens'
import { getWhitelistedTokens } from 'vvs-config'

const getTokenImageByAddress = (address: string) => {
  const tokenWhiteListConfig = getWhitelistedTokens()
  const tokensConfig = getTokens()

  const addressMapping = (): string => {
    switch (address) {
      case tokensConfig.xvvs.address:
        return tokensConfig.vvs.address
      default:
        return address
    }
  }
  const logoURI = tokenWhiteListConfig.tokens.filter(
    (item) => item.address.toLowerCase() === addressMapping().toLowerCase(),
  )[0]?.logoURI
  const linkRegex =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[-a-zA-Z0-9@:%._+~#=]{2,256}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/

  return logoURI && logoURI.match(linkRegex)
    ? logoURI
    : `${process.env.REACT_APP_BASE_URL}/images/tokens/${address}.svg`
}

export default getTokenImageByAddress
